import { useEffect } from "react";
import { sortByKey, undoSort } from "../../components/shared/helpers/helper";
import { useCaseListContext } from "../../context/CaseListContext";

export const useCaseSort = () => {
  const { sort, list, setList } = useCaseListContext();

  useEffect(() => {
    if (sort?.value != null && sort?.value !== "") {
      setList(sortByKey(list, sort.value, sort.type));
      localStorage.setItem("sort", JSON.stringify(sort));
    } else if (sort?.value === "") {
      setList(undoSort(list));
    }
  }, [sort]);

  return {};
};
